﻿//#region Angular Imports

import { IQService, ITimeoutService } from 'angular'

//#endregion

//#region Service

import { MeterService, METER_SERVICE_NAME } from '../../../services/meter'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

//#endregion

import { MeterCreateEditController } from './meters-create-edit.directive.constroller'

//#region Asset Imports

import * as TEMPLATE from './meters-create-edit.tpl.html'

//#endregion

// Setup

export class MeterCreateEditDirective
    implements ng.IDirective {

    restrict = 'E'

    controller = [
        $SCOPE_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        $Q_SERVICE_NAME,
        METER_SERVICE_NAME,
        (
            $scope: any,
            $timeout: ITimeoutService,
            $q: IQService,
            meterService: MeterService,
        ) => new MeterCreateEditController(
            $scope,
            $timeout,
            $q,
            MeterService.SIMAX_MODULE_NAME,
            meterService,
        )]

    template = TEMPLATE
}